/* eslint-disable import/prefer-default-export */
/* eslint-disable max-lines */
/* eslint-disable max-len */

import { listLineItemTagsApi, upsertLineItemTagsApi } from 'api/tags';
import { systemConfigActions } from 'store/slices/systemConfigSlice';
import { handleError } from './errorHandlerThunks';

export const listLineItemTags = () => (dispatch) => {
  return listLineItemTagsApi()
    .then((tags) => {
      dispatch(systemConfigActions.updateLineItemTags({ tags }));
      return tags;
    })
    .catch((error) => dispatch(handleError({ error })));
};

export const upsertLineItemTags =
  ({ lineItemId, currentTags, newTags }) =>
  (dispatch) => {
    const currentTagNames = (currentTags || []).map((tag) => tag.tagName || '');
    const newTagNames = (newTags || []).map((tag) => tag.tagName || '');

    const tagsToAdd = (newTags || []).filter((tag) => {
      const tagName = tag.tagName || '';
      return !currentTagNames.includes(tagName);
    });

    const tagsToRemove = currentTagNames.filter((tagName) => !newTagNames.includes(tagName));

    const tagsWithExpiryChanges = newTagNames
      .filter((tagName) => currentTagNames.includes(tagName))
      .filter((tagName) => {
        const currentTag = (currentTags || []).find((tag) => tag.tagName === tagName);
        const newTag = (newTags || []).find((tag) => tag.tagName === tagName);

        if (!currentTag || !newTag) return false;

        const currentExpiry = currentTag.expiry;
        const newExpiry = newTag.expiry;

        const currentExpiryTime = currentExpiry ? new Date(currentExpiry).getTime() : undefined;
        const newExpiryTime = newExpiry ? new Date(newExpiry).getTime() : undefined;

        return currentExpiryTime !== newExpiryTime;
      });

    if (tagsToAdd.length === 0 && tagsToRemove.length === 0 && tagsWithExpiryChanges.length === 0) {
      return Promise.resolve({ updatedLineItemTags: [{ lineItemId, tags: currentTags }] });
    }

    const tagsToAddOrUpdate = [...tagsToAdd];
    tagsWithExpiryChanges.forEach((tagName) => {
      const newTag = (newTags || []).find((tag) => tag.tagName === tagName);
      if (newTag) {
        tagsToAddOrUpdate.push(newTag);
      }
    });

    const addTagsInput = tagsToAddOrUpdate.map((tag) => ({
      tagName: tag.tagName,
      ...(tag.expiry && { expiry: tag.expiry }),
    }));

    const input = [
      {
        lineItemId,
        addTags: addTagsInput.length > 0 ? addTagsInput : undefined,
        removeTags: tagsToRemove && tagsToRemove.length > 0 ? tagsToRemove : undefined,
      },
    ];

    return upsertLineItemTagsApi({ input })
      .then((response) => {
        if (response?.updatedLineItemTags && response.updatedLineItemTags.length > 0) {
          const updatedItem = response.updatedLineItemTags.find(
            (item) => item.lineItemId === lineItemId
          );
          const updatedTags =
            updatedItem && Array.isArray(updatedItem.tags) ? updatedItem.tags : currentTags || [];
          return {
            updatedLineItemTags: [
              {
                lineItemId,
                tags: updatedTags,
              },
            ],
          };
        }
        return response;
      })
      .catch((error) => dispatch(handleError({ error })));
  };

export const bulkUpsertLineItemTags =
  ({ lineItemUpdates }) =>
  (dispatch) => {
    const input = lineItemUpdates.map((update) => {
      const addTagsInput = update.addTags
        ? update.addTags.map((tagName) => {
            const newTag = (update.newTags || []).find((tag) => tag.tagName === tagName);
            return {
              tagName,
              ...(newTag?.expiry && { expiry: newTag.expiry }),
            };
          })
        : undefined;

      return {
        lineItemId: update.lineItemId,
        addTags: addTagsInput,
        removeTags: update.removeTags,
      };
    });

    return upsertLineItemTagsApi({ input })
      .then((response) => response)
      .catch((error) => dispatch(handleError({ error })));
  };
